import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

@Pipe({
  standalone: true,
  name: 'dateAdd'
})
export class DateAddPipe implements PipeTransform {
  public transform(
    date: Date | string,
    amount: number,
    unit: moment.unitOfTime.DurationConstructor,
    format?: moment.MomentFormatSpecification
  ): Date {
    return moment(date, format).add(amount, unit).toDate();
  }
}
